import { transformDateValue } from 'core/js/FormUtils';
export const getPmorderView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let pmorderList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"productid","fieldValue":transformDataValue(data.productid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"PM Status","fieldValue":transformDataValue(data.pmstatus,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Date","fieldValue":transformDataValue(data.orderdate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Unit Id","fieldValue":transformDataValue(data.unitid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Unit Name","fieldValue":transformDataValue(data.unitname,"string"), "fieldType":"string"},
                            {"fieldLabel":"qty","fieldValue":transformDataValue(data.qty,"double"), "fieldType":"double"},
                            {"fieldLabel":"Received On","fieldValue":transformDataValue(data.receivedon,"date"), "fieldType":"date"},
                            {"fieldLabel":"Available Qty","fieldValue":transformDataValue(data.availableqty,"double"), "fieldType":"double"},
                            {"fieldLabel":"Vendor Id","fieldValue":transformDataValue(data.vendorid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Vendor Name","fieldValue":transformDataValue(data.vendorname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Required Qty","fieldValue":transformDataValue(data.requiredqty,"double"), "fieldType":"double"},
                            {"fieldLabel":"Ordered Qty","fieldValue":transformDataValue(data.orderedqty,"double"), "fieldType":"double"},
              
              
            ],
            'dataList': [
                
              ]
          }

          pmorderList.push(card);
  })
  return pmorderList;
}